<!-- @veltra/icons generated sha256:0694b8cc7c11de8b gen:8 source:src/svg/normal/download.svg -->
<script setup lang="ts">
defineOptions({ name: 'Download' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m8.5 9.577 3.416-3.416a.496.496 0 0 1 .704.01l.008.007a.48.48 0 0 1-.003.689l-4.279 4.279a.48.48 0 0 1-.692 0L3.375 6.867a.493.493 0 0 1 .005-.697.496.496 0 0 1 .704-.009L7.5 9.577V1c0-.276.209-.5.485-.5h.011c.276 0 .504.224.504.5zM2 13v-1.49a.51.51 0 0 1 .496-.51c.276 0 .504.233.504.51V13h10v-1.49a.51.51 0 0 1 .496-.51c.276 0 .504.233.504.51V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1"
    />
  </svg>
</template>
